import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Modal, Spinner, Accordion } from 'react-bootstrap';
import $ from 'jquery';
import { AppContext } from '../App';


export const Work = () => {
	const { accessToken, user, setAuthForm, link, customers, setCustomers, setGetWorkLoad, works, getWorkLoad, setWorks, postCall, getCall } = useContext(AppContext);

	const [newEnquiryModel, setNewEnquiryModel] = useState(false);
	const [phoneReqErr, setPhoneReqErr] = useState(false);
	const [nameReqErr, setNameReqErr] = useState(false);
	const [eqTitleErr, setEqTitleErr] = useState(false);
	const [eqDetailsErr, setEqDetailsErr] = useState(false);
	const [selectCount, setSelectCount] = useState(-1);
	const [showAutoSuggestion, setShowAutoSuggestion] = useState(false);
	const [selectedItem, setSelectedItem] = useState();
	useEffect(() => {
		if (selectedItem !== undefined) {
			$('#cus_phone').val(selectedItem.profile.phone);
			$('#cus_name').val(selectedItem.profile.name);
			$('#cus_address').val(selectedItem.profile.address);
		} else {
			$('#cus_name').val('');
			$('#cus_address').val('');
		}
	}, [selectedItem]);
	const [searchResult, setSearchResult] = useState({});
	const searchCustomer = (c_num) => {
		setSearchResult(prev => { });
		if (c_num !== "") {
			if (customers !== undefined) {
				setSelectedItem();
				if (Object.keys(customers).length > 0) {
					setSelectCount(-1);
					setShowAutoSuggestion(true);
					let count = 0;
					Object.keys(customers).map(customer => {
						if (customers[customer].phone.match(c_num)) {
							if (count < 20) {
								setSearchResult(prev => ({ ...prev, [customer]: customers[customer] }))
								count += 1;
							}
						}
					});
				}
			}
		} else {
			setSearchResult(prev => { });
		}
	}
	$('#cus_phone').off().on("keydown", function (e) {
		var code = e.which || e.keyCode;
		if (code === 40) {
			e.preventDefault();
			if (selectCount < Object.keys(searchResult).length - 1) {
				setSelectCount(prev => prev + 1);
			} else {
				setSelectCount(0);
			}
		} else if (code === 38) {
			e.preventDefault();
			if (selectCount > 0) {
				setSelectCount(prev => prev - 1);
			} else {
				setSelectCount(Object.keys(searchResult).length - 1);
			}
		} else if (code === 13) {
			e.preventDefault();
			setShowAutoSuggestion(false);
			if (selectCount >= 0) {
				setSelectedItem({ id: Object.keys(searchResult)[selectCount], profile: searchResult[Object.keys(searchResult)[selectCount]] });
			}
		}
	});
	const [addEnquiryLoad, setAddEnquiryLoad] = useState(false);
	const addEnquiry = (e) => {
		e.preventDefault();
		let phone = e.target.phone.value;
		let name = e.target.name.value;
		let address = e.target.address.value;
		let title = e.target.title.value;
		let details = e.target.details.value;
		if (phone === "") {
			setPhoneReqErr(true);
			setTimeout(() => { setPhoneReqErr(false) }, 5000);
		}
		if (name === "") {
			setNameReqErr(true);
			setTimeout(() => { setNameReqErr(false) }, 5000);
		}
		if (title === "") {
			setEqTitleErr(true);
			setTimeout(() => { setEqTitleErr(false) }, 5000);
		}
		if (details === "") {
			setEqDetailsErr(true);
			setTimeout(() => { setEqDetailsErr(false) }, 5000);
		}
		if (phone !== "" && name !== "" && title !== "" && details !== "") {
			setAddEnquiryLoad(true);
			postCall('api/e/add/pending/work/', {
				customer_id: selectedItem !== undefined ? selectedItem.id.substring(1) : '',
				name: name,
				phone: phone,
				address: address,
				title: title,
				note: details,
			}).then((response) => {
				setAddEnquiryLoad(false);
				setWorks(response.data.enquiry);
				setCustomers(response.data.customers);
				setNewEnquiryModel(false);
			}).catch((err) => {
				setAddEnquiryLoad(false);
			});
		}
	}
	const pending = (enq) => {
		setResolveLoad(true);
		postCall('api/e/pending/work/', {
			enquiry_id: enq.substring(1),
		}).then((response) => {
			setResolveLoad(false);
			setWorks(response.data);
		}).catch((err) => {
			setResolveLoad(false);
		});
	}
	const [resolveLoad, setResolveLoad] = useState(false);
	const [eqId, setEqId] = useState();
	const resolved = (enq) => {
		setResolveLoad(true);
		postCall('api/e/resolve/pending/work/', {
			enquiry_id: enq.substring(1),
		}).then((response) => {
			setResolveLoad(false);
			setWorks(response.data);
		}).catch((err) => {
			setResolveLoad(false);
		});
	}
	const [resolvedEnq, setResolvedEnq] = useState();
	const [pendingEnq, setPendingEnq] = useState();
	const [tabState, setTabState] = useState('home');
	const getResolved = (key) => {
		setTabState(key);
		// Update button states
		document.querySelectorAll('.works-nav-item').forEach((btn, idx) => {
			btn.classList.remove('active');
		});
		const buttons = document.querySelectorAll('.works-nav-item');
		const indicator = document.querySelector('.works-nav-indicator');
		if (key === 'home') {
			buttons[0].classList.add('active');
			indicator.style.left = '6px';
		} else if (key === 'pending') {
			buttons[1].classList.add('active');
			indicator.style.left = 'calc(33.33% + 2px)';
			getCall(setGetWorkLoad, 'api/e/get/pending/pending/work/', setPendingEnq);
		} else if (key === 'history') {
			buttons[2].classList.add('active');
			indicator.style.left = 'calc(66.66% - 2px)';
			getCall(setGetWorkLoad, 'api/e/get/resolved/pending/work/', setResolvedEnq);
		}
		// Update content visibility
		document.querySelectorAll('.works-tab-content').forEach((content, idx) => {
			content.style.display = 'none';
		});
		const contents = document.querySelectorAll('.works-tab-content');
		if (key === 'home') contents[0].style.display = 'block';
		else if (key === 'pending') contents[1].style.display = 'block';
		else if (key === 'history') contents[2].style.display = 'block';
	}
	const resolvedPeding = (enq) => {
		setResolveLoad(true);
		postCall('api/e/resolve/pending/work/pending/', {
			enquiry_id: enq.substring(1),
		}).then((response) => {
			setResolveLoad(false);
			setPendingEnq(response.data);
		}).catch((err) => {
			setResolveLoad(false);
		});
	}
	return (
		<div className='container-fluid my-3'>

			<div className="p-2 bgp br-3 d-flex align-items-center justify-content-between" >
				<span>{getWorkLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Pending works.'}</span>
				{
					user !== undefined ? (
						user.type === 'admin' ? (
							<Button className="btn-t1" onClick={() => { setNewEnquiryModel(true) }}  ><i className="bi bi-plus-circle"></i> Add new</Button>
						) : (
							user.permission !== undefined ? (
								user.permission.enquiry !== undefined && user.permission.enquiry.A ? (
									<Button className="btn-t1" onClick={() => { setNewEnquiryModel(true) }}  ><i className="bi bi-plus-circle"></i> Add new</Button>
								) : ''
							) : ''
						)
					) : ''
				}
			</div>
			{/* Modern Segmented Control Navigation */}
			<div className="works-nav-container">
				<div className="works-nav-wrapper">
					<button
						className="works-nav-item active"
						onClick={() => getResolved('home')}
					>
						<i className="bi bi-list-task"></i>
						<span>Works</span>
					</button>
					<button
						className="works-nav-item"
						onClick={() => getResolved('pending')}
					>
						<i className="bi bi-hourglass-split"></i>
						<span>Pending</span>
					</button>
					<button
						className="works-nav-item"
						onClick={() => getResolved('history')}
					>
						<i className="bi bi-check-circle"></i>
						<span>Resolved</span>
					</button>
					<div className="works-nav-indicator"></div>
				</div>
			</div>


			{/* Content Area */}
			<div className="works-content-area">
				<div className="works-tab-content">
					{
						works !== undefined ? (
							Object.keys(works).length > 0 ? (
								Object.keys(works).map((enq, enq_i) => (
									works[enq].resolved === false ? (
										<div className="enquiry-item align-items-center justify-content-between grid6by4" key={`enq_${enq_i}`} >
											<Accordion className='p-2' >
												<Accordion.Item eventKey="0">
													<Accordion.Header><span className="tp1 f18" >{works[enq].title} [ {works[enq].username} ]</span></Accordion.Header>
													<Accordion.Body>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-calendar-event'></i><span>Created date</span></div><div className='enquiry-detail-value'>{works[enq].created_date}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-person'></i><span>Customer Name</span></div><div className='enquiry-detail-value'>{works[enq].name}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-telephone'></i><span>Contact number</span></div><div className='enquiry-detail-value'>{works[enq].phone}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-geo-alt'></i><span>Address</span></div><div className='enquiry-detail-value multiline'>{works[enq].address}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-chat-left-text'></i><span>Details</span></div><div className='enquiry-detail-value multiline'>{works[enq].enquiry_details}</div></div>
													</Accordion.Body>
												</Accordion.Item>
											</Accordion>
											{
												user !== undefined ? (
													user.type === 'admin' ? (
														eqId !== undefined && eqId === enq && resolveLoad ? (
															<Button className="enquiry-action-btn" disabled><Spinner animation="border" size="sm" /><span>Processing...</span></Button>
														) : (
															<div className="enquiry-actions d-flex justify-content-end align-items-center">
																<Button onClick={() => {
																	pending(enq);
																	setEqId(enq);
																}} className="enquiry-action-btn pending"><i className="bi bi-hourglass-split"></i>Mark as Pending</Button>
																<Button onClick={() => {
																	resolved(enq);
																	setEqId(enq);
																}} className="enquiry-action-btn resolve"><i className="bi bi-check-circle"></i>Mark as resolved</Button>
															</div>
														)
													) : (
														user.permission !== undefined ? (
															user.permission.enquiry !== undefined && user.permission.enquiry.E ? (
																eqId !== undefined && eqId === enq && resolveLoad ? (
																	<Button className="enquiry-action-btn" disabled><Spinner animation="border" size="sm" /><span>Processing...</span></Button>
																) : (
																	<div className="enquiry-actions d-flex justify-content-end align-items-center">
																		<Button onClick={() => {
																			pending(enq);
																			setEqId(enq);
																		}} className="enquiry-action-btn pending"><i className="bi bi-hourglass-split"></i>Mark as Pending</Button>
																		<Button onClick={() => {
																			resolved(enq);
																			setEqId(enq);
																		}} className="enquiry-action-btn resolve"><i className="bi bi-check-circle"></i>Mark as resolved</Button>
																	</div>

																)
															) : ''
														) : ''
													)
												) : ''
											}
										</div>
									) : ''
								))
							) : 'Not found!'
						) : 'Not found'
					}
				</div>
				<div className="works-tab-content" style={{ display: 'none' }}>
					{
						pendingEnq !== undefined ? (
							Object.keys(pendingEnq).length > 0 ? (
								Object.keys(pendingEnq).map((enq, enq_i) => (
									pendingEnq[enq].resolved === false && pendingEnq[enq].pending ? (
										<div className="enquiry-item align-items-center justify-content-between grid8by2" key={`enq_${enq_i}`} >
											<Accordion className='p-2' >
												<Accordion.Item eventKey="0">
													<Accordion.Header><span className="tp1 f18" >{pendingEnq[enq].title}  [ {pendingEnq[enq].username} ]</span></Accordion.Header>
													<Accordion.Body>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-calendar-event'></i><span>Created date</span></div><div className='enquiry-detail-value'>{pendingEnq[enq].created_date}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-person'></i><span>Customer Name</span></div><div className='enquiry-detail-value'>{pendingEnq[enq].name}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-telephone'></i><span>Contact number</span></div><div className='enquiry-detail-value'>{pendingEnq[enq].phone}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-geo-alt'></i><span>Address</span></div><div className='enquiry-detail-value multiline'>{pendingEnq[enq].address}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-chat-left-text'></i><span>Details</span></div><div className='enquiry-detail-value multiline'>{pendingEnq[enq].enquiry_details}</div></div>
													</Accordion.Body>
												</Accordion.Item>
											</Accordion>
											<div className="enquiry-actions flex-wrap justify-content-end align-items-center">
												{
													user !== undefined ? (
														user.type === 'admin' ? (
															eqId !== undefined && eqId === enq && resolveLoad ? (
																<Button className="enquiry-action-btn" disabled><Spinner animation="border" size="sm" /><span>Processing...</span></Button>
															) : (
																<Button onClick={() => {
																	resolvedPeding(enq);
																	setEqId(enq);
																}} className="enquiry-action-btn resolve"><i className="bi bi-check-circle"></i>Mark as resolved</Button>
															)
														) : (
															user.permission !== undefined ? (
																user.permission.enquiry !== undefined && user.permission.enquiry.E ? (
																	eqId !== undefined && eqId === enq && resolveLoad ? (
																		<Button className="enquiry-action-btn" disabled><Spinner animation="border" size="sm" /><span>Processing...</span></Button>
																	) : (
																		<Button onClick={() => {
																			resolvedPeding(enq);
																			setEqId(enq);
																		}} className="enquiry-action-btn resolve"><i className="bi bi-check-circle"></i>Mark as resolved</Button>
																	)
																) : ''
															) : ''
														)
													) : ''
												}
											</div>
										</div>
									) : ''
								))
							) : 'Not found!'
						) : 'Not found'
					}
				</div>
				<div className="works-tab-content" style={{ display: 'none' }}>
					{
						resolvedEnq !== undefined ? (
							Object.keys(resolvedEnq).length > 0 ? (
								Object.keys(resolvedEnq).map((enq, enq_i) => (
									resolvedEnq[enq].resolved ? (
										<div className="enquiry-item align-items-center justify-content-between grid8by2" key={`enq_${enq_i}`} >

											<Accordion className='p-2' >
												<Accordion.Item eventKey="0">
													<Accordion.Header><span className="tp1 f18" >{resolvedEnq[enq].title} [ {resolvedEnq[enq].username} ]</span></Accordion.Header>
													<Accordion.Body>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-calendar-event'></i><span>Created date</span></div><div className='enquiry-detail-value'>{resolvedEnq[enq].created_date}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-calendar-event'></i><span>Resolved date</span></div><div className='enquiry-detail-value'>{resolvedEnq[enq].updated_date}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-person'></i><span>Customer Name</span></div><div className='enquiry-detail-value'>{resolvedEnq[enq].name}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-telephone'></i><span>Contact number</span></div><div className='enquiry-detail-value'>{resolvedEnq[enq].phone}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-geo-alt'></i><span>Address</span></div><div className='enquiry-detail-value multiline'>{resolvedEnq[enq].address}</div></div>
														<div className='enquiry-detail-row'><div className='enquiry-detail-label'><i className='bi bi-chat-left-text'></i><span>Details</span></div><div className='enquiry-detail-value multiline'>{resolvedEnq[enq].enquiry_details}</div></div>
													</Accordion.Body>
												</Accordion.Item>
											</Accordion>
											<div className='d-flex align-items-center justify-content-end'>
												<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Resolved</span>
											</div>
										</div>
									) : ''
								))
							) : ''
						) : 'Not found'
					}
				</div>
			</div>
			<Modal size="xl" show={newEnquiryModel} backdrop="static" onHide={() => { setNewEnquiryModel(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Add Pending work</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={addEnquiry} >
						<Form.Group className="mb-3">
							<Form.Label>Contact number {phoneReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<div className="serach-customer d-grid pos-rel">
								<Form.Control onBlur={() => {
									setTimeout(() => {
										setShowAutoSuggestion(false);
									}, 100);
								}} autoComplete="off" onWheel={(e) => { e.target.blur() }} id="cus_phone" onChange={(e) => { searchCustomer(e.target.value) }} type="number" name="phone" className="shadow-none br-2" placeholder="Contact number" />

								{
									searchResult !== undefined && showAutoSuggestion ? (
										Object.keys(searchResult).length > 0 ? (
											<div className="customer-search-results bdr1">
												{
													Object.keys(searchResult).map((cus, cus_index) => (
														<span onClick={() => { setSelectedItem({ id: cus, profile: searchResult[cus] }) }} className={cus === Object.keys(searchResult)[selectCount] ? 'd-grid bdrb1 active' : 'd-grid bdrb1'} key={`cust_${cus_index}`}>{searchResult[cus].name} - {searchResult[cus].phone} </span>
													))
												}
											</div>
										) : ''

									) : ''
								}

							</div>
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Name {nameReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control type="text" id="cus_name" name="name" className="shadow-none br-2" placeholder="Customer Name" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Address</Form.Label>
							<Form.Control as="textarea" id="cus_address" className="shadow-none br-2" name="address" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Title {eqTitleErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control type="text" name="title" className="shadow-none br-2" placeholder="Pending work title" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Details {eqDetailsErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control as="textarea" className="shadow-none br-2" name="details" />
						</Form.Group>
						<div className="d-grid">
							{
								addEnquiryLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="btn-t1">SAVE</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
		</div>
	);
}